// extracted by mini-css-extract-plugin
export default {"cls1":"common-cls1__A4","cls2":"common-cls2_ewT common-cls1__A4"};